export default __webpack_public_path__ + "static/media/NewCapital.56fe294c.png";